import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import axios from 'axios';
import FeatureUtils from "../../utils/FeatureUtils";

class ComponentStatusTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            info: '',
            uploading: false
        };
    }

    async executeAction(ev) {
        ev.preventDefault();
        if (this.state.uploading) {
            return;
        }

        this.setState({info: ''});
        const current = this.props.feature;
        const sendData = {};

        // send data
        const url = FeatureUtils.prepareUrl(current, this.props.tab.url);
        const config = {
            headers: {}
        };
        if (this.props.tab.config.headers) {
            Object.keys(this.props.tab.config.headers).forEach(k => {
                config.headers[k] = FeatureUtils.prepareUrl(current, this.props.tab.config.headers[k]);
            });
        }

        this.setState({uploading: true});

        const method = this.props.tab.config.method || 'get';
        let sendAction = null;
        switch (method) {
            case 'get':
                sendAction = axios.get(url, config);
                break;
            case 'post':
                sendAction = axios.post(url, sendData, config);
                break;
            case 'patch':
                sendAction = axios.patch(url, sendData, config);
                break;
            case 'delete':
                sendAction = axios.delete(url, config);
                break;
        }
        const self = this;
        sendAction
            .catch(function (error) {
                console.log('Error sending', error);
                self.triggerError();
            })
            .then(res => {
                this.setState({uploading: false});
                if (typeof res === 'undefined') {
                    self.triggerError();
                } else {
                    self.triggerSuccess();
                }
            });
    }

    triggerAction(e) {
        switch (e.type) {
            case 'message':
                this.setState({info: e.message});
                break;
        }
    }

    triggerSuccess() {
        if (this.props.tab.config.success) {
            this.props.tab.config.success.forEach(e => {
                this.triggerAction(e);
            });
        }
    }

    triggerError() {
        if (this.props.tab.config.error) {
            this.props.tab.config.error.forEach(e => {
                this.triggerAction(e);
            });
        }
    }

    render() {
        const label = this.props.tab.config.label;
        const content = this.props.tab.config.content;
        return (
            <div className="feature-details-ajax">
                <div>
                    {this.state.info}
                </div>
                <form onSubmit={ev => this.executeAction(ev)}>
                    <p>{content}</p>
                    <div>
                        <button className="button">{label}</button>
                    </div>
                </form>
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(ComponentStatusTab);
